export default __webpack_public_path__ + "imgs/w_change_animation_2.png";